import googlePlayBadge from '../assets/badges/google-play-badge.png'
import appStoreBadge from '../assets/badges/app-store-badge.svg'
import { ANDROID_APP_URL as ANDROID_URL, IOS_APP_URL as IOS_URL } from '../constants/appStoreLinks'

/** The "Get it on Google Play" / "Download on the App Store" badge pair, linking to the apps. */
export function StoreBadges({ className = '' }: { className?: string }) {
  return (
    <div className={`flex flex-wrap items-center gap-3 ${className}`}>
      {/* Google's official PNG bakes in a wide transparent margin around the pill (the visible
          badge fills only ~2/3 of the image height), while Apple's SVG is cropped tight to its
          pill. At equal CSS heights the Play badge reads visibly smaller, so it gets a taller box
          here to make the two pills match. */}
      <a href={ANDROID_URL} target="_blank" rel="noopener noreferrer" aria-label="Get YellowDots AI on Google Play">
        <img src={googlePlayBadge} alt="Get it on Google Play" className="h-16 w-auto" />
      </a>
      <a href={IOS_URL} target="_blank" rel="noopener noreferrer" aria-label="Download YellowDots AI on the App Store">
        <img src={appStoreBadge} alt="Download on the App Store" className="h-11 w-auto" />
      </a>
    </div>
  )
}
